module.exports = __webpack_public_path__ + "static/img/flower.3482922b.gif";